export const AKSHAY_BX = [
  "clpnq2knw16ytpcqca7cfun7b",
  "cmmysi9yg02n1pc0xa0812tu2",
  "cmoyfjvp10a3upc42a38lep71",
];
